declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function initMetaPixel() {
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  window.fbq('init', '1279297870750325')
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
